import type { Story3FeedbackModeId } from '../../types';

export interface Story3ModeDef {
  id: Story3FeedbackModeId;
  title: string;
  description: string;
}

export const STORY3_MODES: readonly Story3ModeDef[] = [
  {
    id: 'correction',
    title: 'Korrektur',
    description:
      'Stavning, komma, punktum og stort begyndelsesbogstav — uden at omskrive hele teksten.',
  },
  {
    id: 'assessment',
    title: 'Vurdering',
    description: 'Hvad der virker i din tekst, og hvad du kan styrke næste gang.',
  },
  {
    id: 'question',
    title: 'Fortsættelsesspørgsmål',
    description:
      'Et spørgsmål der får dig til at skrive videre — med navne og detaljer fra din historie.',
  },
  {
    id: 'expert',
    title: 'Fagperson',
    description:
      'Din tekst behandles af en fagperson — analyse og kritik, ikke skoleråd. Skriv videre og vælg samme eller ny læser.',
  },
] as const;

export const STORY3_MIN_CHARS = 50;

export function story3ModeDef(id: Story3FeedbackModeId): Story3ModeDef {
  return STORY3_MODES.find((m) => m.id === id) ?? STORY3_MODES[0]!;
}
